import { CommonUtilities } from "../../../commonUtils";
import Pagination from "components/Common/newPagination";
import React, { Suspense, useState, useEffect } from "react";
import songServices from "./songServices";
import ViewContractAsset from "../../Common/ViewContractAsset";

export default function SongListing(projectDetails : any){

    const [totalRows ,setTotalRows] = useState(1);
    var dataLink = "pageSize=10&pageNumber=1"; 
    const [songslist, initSongslist] = useState<any[]>([]);

    const Data:any =  {
        pageSize : 10,
        pageNumber : 1 ,
        ProjectId: projectDetails.projectDetails.ProjectId,
        assetType : 'song'
    }
    const handleNameOnChange = (n: any) => {  
        Data.pageNumber = n.pageNumber;
        Data.pageSize =n.pageSize;
        getSongs()
    }

    useEffect(() => {
        getSongs()       
    }, []);
    
    const getSongs = () => {
        dataLink = 'projectId='+Data.ProjectId + '&assetType='+Data.assetType + '&pageSize=' + Data.pageSize +'&pageNumber=' + Data.pageNumber;
        Data.ProjectId =projectDetails.projectDetails.ProjectId ;
        songServices.SongListing(dataLink)
        .then((res) => {
            if(res.length === 0){
                projectDetails.onChange(0)
                setTotalRows(0);
            }else{
                initSongslist(res)
                setTotalRows(res[0].totalRows)
                projectDetails.onChange(res[0].totalRows)
            }


        })
    };

    return (
        
        <div >
            <div className="box-content p0">
            <Suspense fallback={<div>Loading</div>}>

                <div className="allowHscroll">
                    {               
                        (() => {
                            if(totalRows && totalRows>0){
                                return (
                                    <table>
                                        <thead>
                                            <tr className="forceSingleLine">
                                                <th>Song Code</th>
                                                <th>Song Title</th>
                                                <th>Song Main Composer</th>
                                                <th>Song Main Publisher</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                songslist.map(post => (
                                                    <tr>
                                                        <td className="forceSingleLine" >
                                                            <span>{post.code}</span>                                  
                                                            {<ViewContractAsset data={post} type="song" projectId={Data.ProjectId}/>/* */}
                                                        </td>
                                                        <td>{post.name}</td>
                                                        <td>{post.songMainComposer}</td>
                                                        <td>{post.songMainPublisher}</td>
                                                    </tr>
                                                ))
                                            }
                    
                                        </tbody>
                                    </table>
                                )
                            }else {
                                return (<div className="ptl">
                                    <span className="alert alert-success ws-12 text-center">No data Available</span>
                                </div>)
                            }
                            
                        })()
                        
                    }  

                </div>


                <div className="ws-12">               
                    {               
                        (() => {
                            if(totalRows && totalRows>10){
                                return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                            }
                            
                        })()
                        
                    }  
                </div>
            
            </Suspense>
            </div>
        </div>
    )
}